import { OnInit, OnDestroy } from '@angular/core';
import { Component } from '@angular/core';
import { IContextService, PershingTranslationService } from '@pershing/pershing-core';
import { NxiRestService } from '../../services/NXI-Rest.service';

declare let dojoApp: any;

@Component({
    selector: 'dojo-login-messages',
    templateUrl: './dojo-login-messages.component.html'
})
export class DojoLoginMessagesComponent implements OnInit, OnDestroy {
    inputValue: string = '';
    domain: string = '';
    acctRef: string = '';
    constructor(
        private contextService: IContextService,
        private translationService: PershingTranslationService,
        private nxiRestService: NxiRestService
    ) {
        this.translationService.addTranslationFolder('@pershing/nxi-ng-portfolio', 'node_modules/@pershing/nxi-ng-portfolio/lib');
    }

    ngOnInit() {
        if (dojoApp) {
            dojoApp.renderLoginMessages();
        }
        if (dojoApp && !!localStorage.getItem('lp') && localStorage.getItem('lp') === 'true') {
            dojoApp.publishMessages(this.acctRef, this.nxiRestService.serviceUrl + '/portfolio/messages');
            localStorage.removeItem('lp');
        }
    }

    ngOnDestroy(): void {
        if (dojoApp) {
            dojoApp.destroyWidget('loginmessages');
        }
    }
}
